module.exports = "<nb-menu [items]=\"items\" autoCollapse=\"true\"></nb-menu>\n"